const en = {
  // Authentication
  "login": "Login",
  "logout": "Logout",
  "password": "Password",
  "confirm_password": "Confirm Password",
  "forgot_password": "Forgot password?",
  "reset_password": "Reset Password",
  "reset_password_message": "Welcome {ph_name}! Here you can reset your password.",
  "register": "Register",
  "register_message": "Welcome to 42Workspace {ph_name}! We are glad to have you here.",
  "my_account": "My Account",
  "username": "Username",

  // Account/User Info
  "account": "Account",
  "name": "Name",
  "email": "Email",
  "image": "Image",
  "personal_code": "Personal Code",
  "date_added": "Date Created",
  "role": "Role",
  "roles": "Roles",
  "rights": "Rights",
  "identifier": "System Identifier",
  "delete_account": "Delete Account",
  "user": "User",
  "users": "Users",
  "company_manager": "Company Manager",
  "default_role": "Default Role of Company",
  "system_account": "System Account",
  "system_accounts": "system accounts",
  "email_bookings": "Confirmation emails for bookings",
  "email_invitations": "Receive emails for invitations",

  // Company
  "company": "Company",
  "companies": "Companies",
  "my_company": "My Company",
  "manage_company": "Manage Company",
  "delete_users_in_company": "Delete users in company",
  "keep_users_in_company": "Keep users in company",
  "max_users": "Maximum Users",

  // UI / General
  "welcome": "Welcome",
  "home": "Home",
  "settings": "Settings",
  "information": "Information",
  "info": "Information",
  "pages": "Pages",
  "page": "Page",
  "order": "Order",
  "move_up": "Move Up",
  "move_down": "Move Down",
  "show_more": "Show more",
  "showing": "Showing {ph_length} of {ph_count}",
  "select": "Select",
  "no_results": "No results",
  "availability": "Availability",
  "date": "Date",
  "time": "Time",
  "new": "New",
  "content": "Content",
  "confirm": "Confirm",
  "close": "Close",
  "add": "Add",
  "remove": "Remove",
  "edit": "Edit",
  "clear": "Clear",
  "actions": "Actions",
  "delete": "Delete",
  "amount_of": "Amount of",
  "language": "Language",
  "theme": "Theme",
  "language_codes": {
    "EN": "English",
    "NL": "Dutch"
  },
  "themes": {
    "light_mode": "Light Mode",
    "dark_mode": "Dark Mode",
    "barbie_mode": "Barbie Mode",
    "smurf_mode": "Smurf Mode",
    "shrek_mode": "Shrek Mode",
  },

  // Booking
  "all_bookings": "View all bookings",
  "cannot_extend": "Cannot extend this booking, try another room!",
  "booking": "Booking",
  "book": "Book",
  "bookings": "Bookings",
  "make_booking": "Make a booking",
  "book_a_room": "Book a room",
  "your_booking": "your booking",
  "my_bookings": "My Bookings",
  "upcoming_bookings": "Upcoming Bookings",
  "no_bookings": "You currently have no bookings...",
  "no_upcoming_bookings": "You currently have no upcoming bookings...",
  "want_to_create": "Do you want to book a room?",
  "room_availability": "Room Availability",
  "title": "Title",
  "description": "Description",
  "attendees": "Attendees",
  "extend_booking": "Extend booking",
  "manage_booking": "Manage booking",
  "open_times": "Opening hours",
  "hours": "hours",
  "timeline": "Timeline",
  "upcoming": "Upcoming",
  "creator": "Creator",

  // Room
  "room": "Room",
  "rooms": "Rooms",
  "room_type": "Room Type",
  "capacity": "Capacity",
  "floor": "Floor",
  "opening_hours": "Opening Hours",
  "opening_time": "Opening Time",
  "closing_time": "Closing Time",
  "active": "Active",
  "inactive": "Inactive",

  // Preferences / Integrations
  "preferences": "Preferences",
  "third_party_integrations": "Third Party Integrations",
  "notifications": "Notifications",
  "sync_calendar": "Sync Calendar",
  "current_users": "Current Users",
  "credits": "Credits",
  "pending_registrations": "Pending Registrations",
  "resend": "Resend",

  // Filters & Display
  "filters": "Filters",
  "display": {
    "currentlyOccupied": "Currently occupied",
    "free": "Free",
    "bookRoom": "Book a room",
    "minutes": "minutes",
    "welcome": "Welcome",
    "bookingFrom": "Your booking is from",
    "to": "to",
    "enterPassword": "Enter system password:",
    "loggingOut": "Logging out...",
    "logout": "Logout",
    "logoutSuccess": "Successfully logged out",
    "logoutError": "Incorrect password or logout failed",
    "quickBook": "Quick Book",
    "till": "till",
    "book": "Book",
    "from": "from",
    "signInPC": "Sign in using personal code",
    "signInQR": "Sign in using QR code",
    "confirmBooking": "Confirm Quick Booking",
    "qrUnavailable": "No QR code available",
    "closingIn": "Closing in",
    "second": "second",
    "secondPlural": "s",
    "minute": "minute"
  },

  // Admin Panel
  "admin": "Admin Panel",
  "admin_tabs": {
    "companies": "Companies",
    "users": "Users",
    "roles": "Roles",
    "rooms": "Rooms",
    "bookings": "Bookings",
    "statistics": "Statistics",
    "info": "Information Pages",
    "systemAccounts": "System Accounts"
  },

  // Toast / System Messages
  "toast": {
    "fill_all_fields": "Please fill all the required fields.",
    "register_message": "Registration link successfully sent to {ph_email}.",
    "reset_password_message": "Password reset link successfully sent to {ph_email}.",
    "reset_email_sent_message": "Please check your mailbox. If the email matches a registered account, you will receive instructions to reset your password.",
    "user_edit": "User {ph_name} updated successfully.",
    "password_mismatch": "Passwords do not match.",
    "register_complete": "Your registration is complete. You can now log in.",
    "password_reset_complete": "Your registration is complete. You can now log in.",
    "server_error": "Sorry, this error is on us. Please try again later.",
    "role_not_empty_error": "This role contains users and cannot be deleted. Please remove all users from this role before deleting it.",
    "created_success": "created successfully.",
    "updated_success": "updated successfully.",
    "deleted_success": "deleted successfully.",
    "confirm_delete_general": "Are you sure you want to delete {ph_name}?",
    "confirm_delete_company": "Are you sure you want to delete {ph_name}? There are {ph_users} users in this company.",
    "register_send_message": "A registration link has been sent to {ph_name}.",
    "booking_success": "Your booking was successful.",
    "name_too_long": "Dang, thats a long name!"
  }
}

export default en;
